export const RECEIVE_WUMEI_REQUEST = 'RECEIVE_WUMEI_REQUEST';
export const SET_WUMEI_FETCHING = 'SET_WUMEI_FETCHING';
